import { graphql } from 'gatsby';
import { applyPaddingCSS } from '@/utils/generatePadding';
import Link from '@/components/Link/Link';
import { Container, Wrapper, Text, Buttons } from './MidPageCTA.styles';
import { type BlockHTMLId } from '@/utils/renderBlock';

export const TIDELIFT_KEY = 'TIDELIFT-VISITOR-ONLY';

const MidPageCTA = ({
  midPageCTAElements,
  system,
  id,
}: Queries.MID_PAGE_CTAFragment & BlockHTMLId) => {
  const titleText = midPageCTAElements.title.value;
  const buttonsArray = midPageCTAElements.buttons.value;
  const isFullWidth = !!midPageCTAElements.options?.value?.includes('full_width');

  return (
    <Container css={applyPaddingCSS(midPageCTAElements)} data-codename={system.codename} id={id}>
      <Wrapper isFullWidth={isFullWidth}>
        <Text>{titleText}</Text>
        <Buttons>
          {buttonsArray.map((button, index: number) => (
            <Link
              {...button}
              variant={index === 0 ? 'primary' : 'secondary'}
              key={button.system.id}
            />
          ))}
        </Buttons>
      </Wrapper>
    </Container>
  );
};

export const fragment = graphql`
  fragment MID_PAGE_CTA on kontent_item_mid_page_cta {
    system {
      codename
    }
    midPageCTAElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      title {
        value
      }
      buttons {
        value {
          system {
            id
          }
          ...LINK
        }
      }
      options {
        value
      }
    }
  }
`;

export default MidPageCTA;
